import React, { useContext } from "react";
import { CybermetrieParamsAMC } from "../../models/CybermetrieParamsAMC";

const defaultContext = new CybermetrieParamsAMC();

const CybermetrieAMCContext = React.createContext(defaultContext);

export const useCybermetrieAMCContext = () => useContext(CybermetrieAMCContext);

export { CybermetrieAMCContext };
